import React, { useState, useCallback, useEffect } from 'react';
import { motion } from 'framer-motion';
import dayjs from 'dayjs';

// Material-UI Core Components
import {
  Paper,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Button,
  FormControl,
  InputLabel,
  Select,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton, FormLabel, FormControlLabel, FormGroup, Checkbox, Snackbar, Alert
} from '@mui/material';
import { axiosInstance, localAxios, localAxiosGet } from '../Axios/axios';
// Material-UI Date Pickers
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// Material-UI Icons
import Add from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import TrendingUp from '@mui/icons-material/TrendingUp'; // For Business Goal / Predefined Business Goals
import Star from '@mui/icons-material/Star';             // For Personal Goal / Other Goals
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import axios from 'axios';



export const projectTimeline = [
  {
    name: 'Project Alpha',
    tasks: [{ name: 'Task A' }, { name: 'Task B' }]
  },
  {
    name: 'Project Beta',
    tasks: [{ name: 'Task X' }, { name: 'Task Y' }]
  }
];

export const performanceCategories = [
  { id: 1, title: 'Efficiency', icon: <AccessTimeIcon /> },
  { id: 2, title: 'Quality', icon: <Star /> },
  { id: 3, title: 'Innovation', icon: <LightbulbIcon /> },
  // Adding some more general categories that could apply to personal goals
  { id: 4, title: 'Health & Wellness', icon: <AccessTimeIcon /> },
  { id: 5, title: 'Skill Development', icon: <LightbulbIcon /> },
  { id: 6, title: 'Financial Growth', icon: <Star /> },
  { id: 7, title: 'Relationships', icon: <AccessTimeIcon /> },
  { id: 8, title: 'Creativity', icon: <LightbulbIcon /> },
];

export const predefinedBusinessGoals = [
  { id: 1, title: 'Increase Sales by 15%', description: 'Focus on new customer acquisition and improving conversion rates. This is a common business objective.' },
  { id: 2, title: 'Reduce Operational Costs by 10%', description: 'Streamline processes and identify areas for cost reduction across departments.' },
  { id: 3, title: 'Improve Customer Satisfaction Score to 90%', description: 'Implement robust feedback mechanisms and promptly address customer pain points and suggestions.' },
  { id: 4, title: 'Launch New Product by Q4', description: 'Complete all phases of product development, testing, and market entry by the end of the fourth quarter.' },
  { id: 5, title: 'Expand Market Share by 5%', description: 'Execute targeted marketing campaigns and strategic partnerships to capture a larger portion of the market.' },
];

export const predefinedPersonalGoals = [
  { id: 1, title: 'Adhere to Company Dress Code', description: 'Consistently follow the established company dress code, ensuring a professional and appropriate appearance in the workplace.' },
  { id: 2, title: 'Maintain Punctual Attendance', description: 'Arrive at work on time for all scheduled shifts and meetings, demonstrating respect for colleagues and company operations.' },
  { id: 3, title: 'Complete All Mandatory Training', description: 'Finish all assigned mandatory HR and compliance training modules (e.g., cybersecurity, ethics, harassment prevention) by their specified deadlines.' },
  { id: 4, title: 'Actively Participate in Performance Reviews', description: 'Engage fully in the performance review process, including completing self-assessments and participating in constructive feedback discussions.' },
  { id: 5, title: 'Contribute to a Safe Work Environment', description: 'Adhere to all company safety policies and procedures, reporting any hazards or incidents promptly to ensure a secure workplace for everyone.' },
];
// --- End of assumed constants ---


function AddGoal({ onClose, onGoalAdded }) {
  const [requestFormData, setRequestFormData] = useState({
    goalType: '',
    businessGoalType: '',
    personalGoalType: '',
    projectName: '',
    taskName: '',
    objectiveTitle: '',
    objectiveTitles: [],
    description: '',
    startDate: null,
    endDate: null,
    improvementCategories: [],
    goalPeriod: '',
  });
  const [allProjects, setAllprojects] = useState([]);
  const [selectedprojectId, setSelectedProjectid] = useState('');
  const [allTaksForSelectedProject, setAllTasksForSelectedProject] = useState([]);
  const [selectedTaskId, setSelectedTaskId] = useState('')
  const [showImprovementCategories, setShowImprovementCategories] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [displayApiMessage, setDisplayApiMessage] = useState('');


  const goalDetailMapping = {
    'Business Goal': {
      'Predefined Business Goals': 'Predefined Business Goals', // Match the exact enum value
      'Other Business Goals': 'Other Business Goals' // Match the exact enum value
    },
    'Personal Goal': {
      'Predefined Personal Goals': 'Predefined Personal Goals', // Match the exact enum value
      'Other Personal Goals': 'Other Personal Goals' // Match the exact enum value
    }
  };
  useEffect(() => {
    fetchAllProjects();
  }, [])

  const emp_id = localStorage.getItem('userId');
  const accessToken = localStorage.getItem('accessToken');
  const fetchAllProjects = async () => {

    try {
      const response = await axiosInstance(localAxiosGet(`/project/getProjectsByEmployeeId/${emp_id}`));
      if (response.data.status === 'SUCCESS') {
        const projectData = response.data.message.data.map(project => ({
          id: project.id,
          name: project.project_title,

        }));
        setAllprojects(projectData);
      }
    } catch (error) {
      console.error('Error in fetching projects', error)
    }
  }
  useEffect(() => {
    fetchTasksForSelectedProject();
  }, [selectedprojectId])

  const fetchTasksForSelectedProject = async () => {
    try {
      const response = await axiosInstance(localAxiosGet(`/task/getAllTasksByEmployeeId/${emp_id}?project_id=${selectedprojectId}`, accessToken));
      if (response.data.status === 'SUCCESS') {
        setAllTasksForSelectedProject(response.data.message.tasks);
      }
    } catch (error) {
      console.error('Error in fetching tasks', error)
    }
  }
  console.log(allProjects, selectedTaskId.selectedprojectId, allTaksForSelectedProject);
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  // New handler specifically for checkboxes (multi-select)
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    setRequestFormData((prevData) => {
      let updatedObjectiveTitles = prevData.objectiveTitles ? [...prevData.objectiveTitles] : [];

      if (checked) {
        updatedObjectiveTitles.push(value);
      } else {
        updatedObjectiveTitles = updatedObjectiveTitles.filter(title => title !== value);
      }

      return {
        ...prevData,
        objectiveTitles: updatedObjectiveTitles,
      };
    });
  };

  // Modified handleRequestFormChange to handle all other input types
  const handleRequestFormChange = (event) => {
    const { name, value, type } = event.target; // Added 'type' to destructure

    setRequestFormData((prevData) => {
      let newState = { ...prevData };

      // Handle checkbox changes separately if the name is 'objectiveTitles' and it's a checkbox type
      // This condition ensures this general handler doesn't interfere with handleCheckboxChange
      if (name === 'objectiveTitles' && type === 'checkbox') {
        // This case should ideally not be reached if handleCheckboxChange is used directly on Checkbox
        // But it's a safeguard. The actual array update logic is in handleCheckboxChange.
        // For a combined handler, you'd put the array logic here.
        // Since we have a separate handleCheckboxChange, we just return prevData or log an error.
        console.warn("handleRequestFormChange received a checkbox event for objectiveTitles. Ensure handleCheckboxChange is used for these inputs.");
        return prevData;
      }

      // Apply the direct value update for non-checkbox inputs
      newState[name] = value;

      // Reset all relevant fields when top-level goalType changes
      if (name === 'goalType') {
        newState = {
          ...prevData,
          [name]: value,
          businessGoalType: '',
          personalGoalType: '',
          projectName: '',
          taskName: '',
          objectiveTitle: '', // For single select
          objectiveTitles: [], // For multi-select
          description: '',
          startDate: null,
          endDate: null,
          goalPeriod: '', // Clear goal period
          improvementCategories: [],
        };
        setShowImprovementCategories(false);
      }
      // Logic when `objectiveTitle` is selected (ONLY for business preset, as personal is now multi-select)
      else if (name === 'objectiveTitle' && prevData.businessGoalType === 'Predefined Business Goals') {
        const selectedGoal = predefinedBusinessGoals.find(g => g.title === value);
        newState.description = selectedGoal ? selectedGoal.description : '';
      }
      // Logic for inner businessGoalType change (Preset Business vs Other Business)
      else if (name === 'businessGoalType') {
        newState = {
          ...prevData,
          [name]: value,
          projectName: '',
          taskName: '',
          objectiveTitle: '',
          description: '',// Reset categories if switching business goal sub-type
        };
        setShowImprovementCategories(false);
      }
      // NEW: Logic for inner personalGoalType change (Predefined Personal vs Other Personal)
      else if (name === 'personalGoalType') {
        newState = {
          ...prevData,
          [name]: value,
          objectiveTitle: '', // Clear single select objectiveTitle (if it was used before)
          objectiveTitles: [], // Clear multi-select objectiveTitles array
          description: '',
          goalPeriod: '', // Clear goal period when personal sub-type changes
          startDate: null, // Clear dates
          endDate: null,
          improvementCategories: [], // Reset categories if switching personal goal sub-type
        };
        setShowImprovementCategories(false); // Hide categories when personal sub-type changes
      }
      return newState;
    });
  };


  const handleStartDateChange = (date) => {
    setRequestFormData(prev => ({
      ...prev,
      startDate: date ? date.format('YYYY-MM-DD') : null,
    }));
  };

  const handleEndDateChange = (date) => {
    setRequestFormData(prev => ({
      ...prev,
      endDate: date ? date.format('YYYY-MM-DD') : null,
    }));
  };


  const handleAddImprovementCategory = () => {
    setShowImprovementCategories(true);
    setRequestFormData((prevData) => ({
      ...prevData,
      improvementCategories: [...prevData.improvementCategories, { category: '', description: '' }],
    }));
  };

  const handleImprovementCategoryChange = (index, field, value) => {
    setRequestFormData((prevData) => {
      const updatedCategories = [...prevData.improvementCategories];
      updatedCategories[index] = { ...updatedCategories[index], [field]: value };
      return { ...prevData, improvementCategories: updatedCategories };
    });
  };

  const handleCloseRequestDialog = () => {
    onClose();
  };
  
  const handleSubmit = async () => {
    setLoading(true);
    const empId = localStorage.getItem('userId');
    const userDetailsStorage = JSON.parse(localStorage.getItem('userDetailsStorage') || '{}');

    const mappedGoalDetail = goalDetailMapping[requestFormData.goalType]?.[
      requestFormData.goalType === 'Business Goal'
        ? requestFormData.businessGoalType
        : requestFormData.personalGoalType
    ] || '';

    // For Personal Goal with predefined goals, handle multiple selections
    let titleValue;
    if (requestFormData.goalType === 'Personal Goal' &&
      requestFormData.personalGoalType === 'Predefined Personal Goals') {
      // If multiple checkboxes are selected, join them with comma
      if (Array.isArray(requestFormData.objectiveTitles) && requestFormData.objectiveTitles.length > 0) {
        titleValue = requestFormData.objectiveTitles.join(', ');
      } else {
        titleValue = requestFormData.objectiveTitle || '';
      }
    } else {
      titleValue = requestFormData.objectiveTitle || '';
    }

    const payload = {
      // Existing fields
      emp_id: [parseInt(empId)], // Wrap in array and convert to number
      goal_type: requestFormData.goalType,
      goal_detail: mappedGoalDetail,
      title: titleValue,
      project_name: selectedprojectId || null,
      task_name: selectedTaskId || null,
      Description: requestFormData.description || "",
      start_date: requestFormData.startDate ? dayjs(requestFormData.startDate).format('YYYY-MM-DD') : null,
      end_date: requestFormData.endDate ? dayjs(requestFormData.endDate).format('YYYY-MM-DD') : null,
      Attachments: "", // Keep existing
      Ratings: 5,
      status: "Pending", // Changed from "Submitted For Review" to match working payload
      catagore_json: requestFormData.improvementCategories.length > 0
        ? requestFormData.improvementCategories
        : null, // Keep existing but can be null
      reporting_mang_id: userDetailsStorage.report_manager_id || null, // Keep existing
      submit_for_review: false, // Changed from true to false to match working payload
      feedback: "Initial draft",
      goal_period: requestFormData.goalPeriod || "", // Keep existing

      // New fields from working payload
      is_manager: false,
      is_hr: false,
      appraisal_period_id: 1 // Add this required field
    };

    console.log("Sending payload:", JSON.stringify(payload, null, 2)); // Debug log

    try {
      const response = await axiosInstance(localAxios('/empGoal/create_EmpGoal', payload));

      console.log("API Response:", response.data);

      if (response.data.status === 'SUCCESS') {
        const messageText = typeof response.data.message === 'object'
          ? response.data.message.msg || JSON.stringify(response.data.message)
          : response.data.message;

        setSnackbar({
          open: true,
          message: messageText,
          severity: 'success',
        });
        setDisplayApiMessage(messageText);

        if (onGoalAdded) {
          onGoalAdded();
        }

        setTimeout(() => {
          setDisplayApiMessage('');
          handleCloseRequestDialog();
        }, 2000);
      } else {
        // Handle other statuses
        const messageText = typeof response.data.message === 'object'
          ? response.data.message.msg || JSON.stringify(response.data.message)
          : response.data.message;

        setSnackbar({
          open: true,
          message: messageText || 'Failed to create goal',
          severity: 'error',
        });
        setDisplayApiMessage(messageText);
      }

    } catch (error) {
      console.error("Error creating goal:", error);
      console.error("Error details:", error.response?.data);

      const errorMessage = error.response?.data?.message;
      const messageText = typeof errorMessage === 'object'
        ? errorMessage.msg || JSON.stringify(errorMessage)
        : errorMessage || 'Error in creating a goal';

      setSnackbar({
        open: true,
        message: messageText,
        severity: 'error',
      });
      setDisplayApiMessage(messageText);
    } finally {
      setLoading(false);
    }
  }



  // Helper function to render content based on goalType and its sub-types
  const renderGoalTypeContent = () => {
    // --- Business Goal Section ---
    if (requestFormData.goalType === 'Business Goal') {
      return (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 2, mb: 3, background: 'linear-gradient(135deg, #ffffff 0%, #f3f4f6 100%)' }}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: 'primary.main' }}>
              Define Business Objective
            </Typography>

            {/* Dropdown for Business Goal Type: Predefined Business Goals vs Other Goals */}
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel id="business-goal-type-label">Goal Details</InputLabel>
              <Select
                labelId="business-goal-type-label"
                id="business-goal-type-select"
                value={requestFormData.businessGoalType}
                label="Goal Details"
                name="businessGoalType"
                onChange={handleRequestFormChange}
              >
                <MenuItem value="Predefined Business Goals">
                  <Box display="flex" alignItems="center">
                    <TrendingUp sx={{ mr: 1 }} />
                    Predefined Business Goals
                  </Box>
                </MenuItem>
                <MenuItem value="Other Business Goals">
                  <Box display="flex" alignItems="center">
                    <Star sx={{ mr: 1 }} />
                    Other Business Goals
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>

            {requestFormData.businessGoalType === 'Predefined Business Goals' && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Select Preset Objective Title"
                      name="objectiveTitle"
                      select
                      value={requestFormData.objectiveTitle}
                      onChange={handleRequestFormChange}
                      sx={{ mb: 2 }}
                    >
                      {predefinedBusinessGoals.map((goal) => (
                        <MenuItem key={goal.id} value={goal.title}>
                          {goal.title}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {requestFormData.objectiveTitle && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        value={requestFormData.description}
                        onChange={handleRequestFormChange}
                        multiline
                        minRows={4}
                        sx={{ mb: 2 }}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="Start Date"
                      value={requestFormData.startDate ? dayjs(requestFormData.startDate) : null}
                      onChange={handleStartDateChange}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth required name="startDate" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="End Date"
                      value={requestFormData.endDate ? dayjs(requestFormData.endDate) : null}
                      onChange={handleEndDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          required
                          name="endDate"
                          sx={{
                            '& .MuiOutlinedInput-root': { borderRadius: '8px', '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' } },
                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' }
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </motion.div>
            )}

            {requestFormData.businessGoalType === 'Other Business Goals' && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Select Project Name"
                      name="projectName"
                      select
                      value={selectedprojectId}
                      onChange={(e) => setSelectedProjectid(e.target.value)}
                    >
                      {allProjects.map((project) => (
                        <MenuItem key={project.id} value={project.id}>
                          {project.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Select Task Name"
                      name="taskName"
                      select
                      value={selectedTaskId}
                      onChange={(e) => setSelectedTaskId(e.target.value)}
                    >
                      {/* {projectTimeline
                        .find((p) => p.name === requestFormData.projectName)
                        ?.tasks.map((task) => (
                          <MenuItem key={task.name} value={task.name}>
                            {task.name}
                          </MenuItem>
                        ))} */}
                      {allTaksForSelectedProject.map((task) => (
                        <MenuItem key={task.task_id} value={task.task_id}>
                          {task.task_title}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Objective Title"
                      name="objectiveTitle"
                      value={requestFormData.objectiveTitle}
                      onChange={handleRequestFormChange}
                      sx={{ mb: 2 }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      value={requestFormData.description}
                      onChange={handleRequestFormChange}
                      multiline
                      minRows={4}
                      sx={{ mb: 2 }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="Start Date"
                      value={requestFormData.startDate ? dayjs(requestFormData.startDate) : null}
                      onChange={handleStartDateChange}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth required name="startDate" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="End Date"
                      value={requestFormData.endDate ? dayjs(requestFormData.endDate) : null}
                      onChange={handleEndDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          required
                          name="endDate"
                          sx={{
                            '& .MuiOutlinedInput-root': { borderRadius: '8px', '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' } },
                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' }
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button onClick={handleAddImprovementCategory} variant="outlined" style={{ marginTop: '10px', marginBottom: '10px' }}>
                      Add Categories
                    </Button>
                    {showImprovementCategories &&
                      requestFormData.improvementCategories.map((item, index) => {
                        return (
                          <Grid container key={index} spacing={2} style={{ marginBottom: '15px' }}>
                            <Grid item xs={4}>
                              <FormControl fullWidth>
                                <InputLabel id={`category-label-${index}`}>Category</InputLabel>
                                <Select
                                  labelId={`category-label-${index}`}
                                  id={`category-${index}`}
                                  value={item.category}
                                  label="Category"
                                  onChange={(e) => handleImprovementCategoryChange(index, 'category', e.target.value)}
                                >
                                  {performanceCategories.map((category) => (
                                    <MenuItem key={category.id} value={category.title}>
                                      <Box display="flex" alignItems="center">
                                        {category.icon}
                                        {category.title}
                                      </Box>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {item.category && (
                              <Grid item xs={8}>
                                <TextField
                                  label="Description"
                                  value={item.description}
                                  onChange={(e) => handleImprovementCategoryChange(index, 'description', e.target.value)}
                                  fullWidth
                                  minRows={4}
                                  multiline
                                />
                              </Grid>
                            )}
                          </Grid>
                        )
                      })}
                  </Grid>
                </Grid>
              </motion.div>
            )}
          </Paper>
        </motion.div>
      );
    }
    // --- Personal Goal Section ---
    else if (requestFormData.goalType === 'Personal Goal') {
      return (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 2, mb: 3, background: 'linear-gradient(135deg, #ffffff 0%, #f3f4f6 100%)' }}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: 'primary.main' }}>
              Define Personal Goal
            </Typography>

            {/* Dropdown for Personal Goal Type: Predefined Personal Goals vs Other Personal Goals */}
            <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel id="personal-goal-type-label">Goal Details</InputLabel>
              <Select
                labelId="personal-goal-type-label"
                id="personal-goal-type-select"
                value={requestFormData.personalGoalType}
                label="Goal Details"
                name="personalGoalType"
                onChange={handleRequestFormChange}
              >
                <MenuItem value="Predefined Personal Goals">
                  <Box display="flex" alignItems="center">
                    <Star sx={{ mr: 1 }} />
                    Predefined Personal Goals
                  </Box>
                </MenuItem>
                <MenuItem value="Other Personal Goals">
                  <Box display="flex" alignItems="center">
                    <LightbulbIcon sx={{ mr: 1 }} />
                    Other Personal Goals
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>

            {requestFormData.personalGoalType === 'Predefined Personal Goals' && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {/* Changed from RadioGroup to Checkbox for multiple selections */}
                    <FormControl component="fieldset" fullWidth sx={{ mb: 2 }}>
                      <FormLabel component="legend">Select Predefined Personal Goal Title(s)</FormLabel>
                      {/* Using a Checkbox group for multiple selections */}
                      <FormGroup row> {/* `row` for horizontal layout */}
                        {predefinedPersonalGoals.map((goal) => (
                          <FormControlLabel
                            key={goal.id}
                            control={
                              <Checkbox
                                // Ensure objectiveTitles is initialized as an array, e.g., []
                                checked={requestFormData.objectiveTitles?.includes(goal.title) || false}
                                onChange={handleCheckboxChange} // Use the new handler for checkboxes
                                // `name` attribute here isn't strictly necessary for checkboxes if handled by custom `handleCheckboxChange`
                                // but can be useful if `handleRequestFormChange` is smart enough to handle arrays
                                // For clarity with handleCheckboxChange, 'name' on Checkbox isn't vital, but `value` is.
                                value={goal.title}
                              />
                            }
                            label={goal.title}
                          />
                        ))}
                      </FormGroup>
                    </FormControl>
                  </Grid>

                  {/* Description field is commented out as requested */}
                  {/*
                        {requestFormData.objectiveTitles && requestFormData.objectiveTitles.length > 0 && (
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Description"
                                    name="description"
                                    value={requestFormData.description || ''} // Provide a default empty string
                                    onChange={handleRequestFormChange}
                                    multiline
                                    minRows={4}
                                    sx={{ mb: 2 }}
                                    // You might want to make this disabled or readOnly if the description is truly fixed for predefined goals
                                    // disabled
                                    // InputProps={{ readOnly: true }}
                                />
                            </Grid>
                        )}
                        */}

                  {/* NEW: Goal Period Dropdown */}
                  <Grid item xs={12}>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <InputLabel id="goal-period-label">Goal Period</InputLabel>
                      <Select
                        labelId="goal-period-label"
                        id="goal-period-select"
                        value={requestFormData.goalPeriod || ''} // Make sure requestFormData has a 'goalPeriod' property
                        label="Goal Period"
                        name="goalPeriod"
                        onChange={handleRequestFormChange} // This can still use the generic handler
                      >
                        <MenuItem value="Quarterly">Quarterly</MenuItem>
                        <MenuItem value="Half-Yearly">Half-Yearly</MenuItem>
                        <MenuItem value="Yearly">Yearly</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Removed Start Date and End Date Pickers for Predefined Personal Goals */}
                  {/* These DatePickers are now fully commented out as they are not needed for predefined goals
                            with a "Goal Period" dropdown. They remain in 'Other Personal Goals' section.
                        */}
                  {/* <Grid item xs={12} sm={6}>
                            <DatePicker
                                label="Start Date"
                                value={requestFormData.startDate ? dayjs(requestFormData.startDate) : null}
                                onChange={handleStartDateChange}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth required name="startDate" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DatePicker
                                label="End Date"
                                value={requestFormData.endDate ? dayjs(requestFormData.endDate) : null}
                                onChange={handleEndDateChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        name="endDate"
                                        sx={{
                                            '& .MuiOutlinedInput-root': { borderRadius: '8px', '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' } },
                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
                                            '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' }
                                        }}
                                    />
                                )}
                            />
                        </Grid> */}
                </Grid>
              </motion.div>
            )}

            {requestFormData.personalGoalType === 'Other Personal Goals' && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Personal Objective Title"
                      name="objectiveTitle"
                      value={requestFormData.objectiveTitle}
                      onChange={handleRequestFormChange}
                      sx={{ mb: 2 }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      value={requestFormData.description}
                      onChange={handleRequestFormChange}
                      multiline
                      minRows={4}
                      sx={{ mb: 2 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="Start Date"
                      value={requestFormData.startDate ? dayjs(requestFormData.startDate) : null}
                      onChange={handleStartDateChange}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth required name="startDate" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DatePicker
                      label="End Date"
                      value={requestFormData.endDate ? dayjs(requestFormData.endDate) : null}
                      onChange={handleEndDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          required
                          name="endDate"
                          sx={{
                            '& .MuiOutlinedInput-root': { borderRadius: '8px', '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' } },
                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' }
                          }}
                        />
                      )}
                    />
                  </Grid>
                  {/* ADDED: Add Categories for Improvement for Other Personal Goals */}
                  <Grid item xs={12}>
                    <Button onClick={handleAddImprovementCategory} variant="outlined" style={{ marginTop: '10px', marginBottom: '10px' }}>
                      Add Categories
                    </Button>
                    {showImprovementCategories &&
                      requestFormData.improvementCategories.map((item, index) => {
                        return (
                          <Grid container key={index} spacing={2} style={{ marginBottom: '15px' }}>
                            <Grid item xs={4}>
                              <FormControl fullWidth>
                                <InputLabel id={`category-label-${index}`}>Category</InputLabel>
                                <Select
                                  labelId={`category-label-${index}`}
                                  id={`category-${index}`}
                                  value={item.category}
                                  label="Category"
                                  onChange={(e) => handleImprovementCategoryChange(index, 'category', e.target.value)}
                                >
                                  {/* Using the same performanceCategories for personal as well for simplicity */}
                                  {performanceCategories.map((category) => (
                                    <MenuItem key={category.id} value={category.title}>
                                      <Box display="flex" alignItems="center">
                                        {category.icon}
                                        {category.title}
                                      </Box>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {item.category && (
                              <Grid item xs={8}>
                                <TextField
                                  label="Description"
                                  value={item.description}
                                  onChange={(e) => handleImprovementCategoryChange(index, 'description', e.target.value)}
                                  fullWidth
                                  minRows={4}
                                  multiline
                                />
                              </Grid>
                            )}
                          </Grid>
                        )
                      })}
                  </Grid>
                </Grid>
              </motion.div>
            )}
          </Paper>
        </motion.div>
      );
    }
    // Default case: Render nothing or a message if no goal type is selected
    return (
      <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 2, background: 'linear-gradient(135deg, #ffffff 0%, #f3f4f6 100%)' }}>
        <Typography variant="body1" color="text.secondary">
          Please select a Goal Type to proceed.
        </Typography>
      </Paper>
    );
  };

  return (
    <>
      <Dialog open={true} onClose={handleCloseRequestDialog} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          bgcolor: 'primary.main',
          color: 'white',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2
        }}>
          <Box display="flex" alignItems="center">
            <Add sx={{ mr: 1 }} />
            Add Your Goals
          </Box>
          <IconButton
            aria-label="close"
            onClick={handleCloseRequestDialog}
            sx={{
              color: 'white'
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3, mt: 2 }}>
          <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 2, mb: 3, background: 'linear-gradient(135deg, #ffffff 0%, #f3f4f6 100%)' }}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: 'primary.main' }}>
              Select Goal Type
            </Typography>

            <FormControl fullWidth variant="outlined">
              <InputLabel id="request-type-label">Goal Type</InputLabel>
              <Select
                labelId="goal-type-label"
                id="goal-type"
                name="goalType"
                value={requestFormData.goalType}
                onChange={handleRequestFormChange}
                label="Goal Type"
                sx={{
                  background: 'white',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#2196F380',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#2196F3',
                  },
                  mb: 2
                }}
              >
                <MenuItem value="Business Goal">
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <TrendingUp sx={{ color: '#2196F3', mr: 1 }} />
                    Business Goal
                  </Box>
                </MenuItem>
                <MenuItem value="Personal Goal">
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Star sx={{ color: '#FFC107', mr: 1 }} />
                    Personal Goal
                  </Box>
                </MenuItem>
              </Select>
            </FormControl>
          </Paper>

          {/* LocalizationProvider now wraps the entire content section */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {renderGoalTypeContent()}
          </LocalizationProvider>


          {/* Unified Submit and Close buttons */}
          {requestFormData.goalType && (
            <Grid container direction="column" sx={{ mt: 3 }}>
              {displayApiMessage && (
                <Typography
                  sx={{
                    mb: 2,
                    fontWeight: 'bold',
                    color: snackbar.severity === 'success' ? 'green' : 'red',
                    textAlign: 'right',
                    width: '100%',
                  }}
                >
                  {displayApiMessage}
                </Typography>
              )}
              <Grid item sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  style={{ marginRight: '8px' }}
                >
                  Submit Goal
                </Button>
                <Button variant="outlined" color="primary" onClick={handleCloseRequestDialog}>
                  Close
                </Button>
              </Grid>
            </Grid>
          )}

        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>

  );
}

export default AddGoal;